import React from 'react';
import AuditRow from './AuditRow';
import Selectors from '../hooks/selectors';

const AuditsTableRows = ({ category, columns, items }) => {
  const state = Selectors.useAuditsTableRows();
  return (
    items.map((item, index) => (
      <AuditRow
        allowCohortLink={state.allowCohortLink}
        allowCollectionLink={state.allowCollectionLink}
        allowDatasetLink={state.allowDatasetLink}
        allowRoleLink={state.allowRoleLink}
        allowSearchLink={state.allowSearchLink}
        allowRequestLink={state.allowRequestLink}
        allowUserLink={state.allowUserLink}
        allowUserGroupLink={state.allowUserGroupLink}
        audit={item}
        category={category}
        columns={columns}
        key={`audits_table_row_${item.code}`}
        upward={index > 4}
      />
    ))
  );
};

export default AuditsTableRows;
